import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { cores } from '../../../../styles/styleUtils';

// Can reuse KPIBox styles or create specific ones if needed
const InfoCardStyled = styled.div`
  background-color: ${cores.chumbo};
  color: white;
  padding: 15px 20px; // Slightly larger padding
  border-radius: 25px; // Highly rounded corners
  text-align: center;
  font-size: 1rem; // Slightly larger font
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

function InfoCard({ text }) {
  return (
    <InfoCardStyled>
        {text}
    </InfoCardStyled>
  );
}

InfoCard.propTypes = {
  text: PropTypes.string.isRequired,
};

export default InfoCard;